import React from "react";
import { Typeahead as BSTypeahead } from "react-bootstrap-typeahead";
import { FormGroup, Label } from "reactstrap";

const Typeahead = props => {
  const { input, id, label, forwardedRef, ...rest } = props;
  let typeAheadRef;
  return (
    <FormGroup>
      {label && <Label htmlFor={id}>{label}</Label>}
      <BSTypeahead
        id={id}
        ref={node => {
          typeAheadRef = node;
          if (typeof forwardedRef === 'function') forwardedRef(node);
        }}
        onChange={tags => {
          input.onChange(tags)
          typeAheadRef.getInstance().focus();
        }}
        {...rest}
      />
    </FormGroup>
  )
}

export default React.forwardRef((props, ref) => <Typeahead {...props} forwardedRef={ref} />)